import React from 'react';
// Components
import ManageDesigns from 'components/common/ManageDesigns';

const ManageOrganizationDesigns = (): JSX.Element => {
  return <ManageDesigns />;
};

export default ManageOrganizationDesigns;
